var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAirtable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.1501 11.8L9.4251 31.55C6.7751 32.65 6.8001 36.425 9.4751 37.475L57.4001 56.475C61.6001 58.15 66.3001 58.15 70.5001 56.475L118.425 37.475C121.1 36.425 121.125 32.65 118.475 31.55L70.7501 11.8C66.4001 10 61.5001 10 57.1501 11.8Z",
    fill: "#FCB400"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1992 66.875V114.35C68.1992 116.6 70.4742 118.15 72.5742 117.325L125.974 96.6C127.199 96.125 127.999 94.95 127.999 93.625V46.15C127.999 43.9 125.724 42.35 123.624 43.175L70.2242 63.9C68.9992 64.375 68.1992 65.55 68.1992 66.875Z",
    fill: "#18BFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 46.35V90.9C0 93.25 2.7 94.8 4.825 93.775L38.275 77.75L39.875 76.975L1.025 44.2C0.425 44.75 0 45.5 0 46.35Z",
    fill: "#F82B60"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7254 69.325L39.8754 76.975L1.02539 44.2C1.27539 43.95 1.55039 43.75 1.82539 43.6C2.62539 43.125 3.77539 43 4.72539 43.375L55.4504 63.475C58.0504 64.5 58.2504 68.1 55.7254 69.325Z",
    fill: "#B01F44"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirtable);
export default __webpack_public_path__ + "static/media/airtable.2d97aa6f1e674c721a8eeac104112284.svg";
export { ForwardRef as ReactComponent };